/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Label_StudentInputs */

const en_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student name`)
};

const es_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del estudiante`)
};

const de_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Golfschülers`)
};

const zh_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学生姓名`)
};

const ar_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسم الطالب`)
};

const fr_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de l’élève`)
};

const vi_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên học viên`)
};

const sw_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jina la mwanafunzi`)
};

const th_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อนักเรียน`)
};

const bs_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ime učenika`)
};

const ja_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生徒名`)
};

const ko_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수강생 이름`)
};

const pt_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do aluno`)
};

const it_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome dell’allievo`)
};

const sv_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevens namn`)
};

const nl_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam student`)
};

const da_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevens navn`)
};

const nb_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevens navn`)
};

const fi_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppilaan nimi`)
};

const pl_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko ucznia`)
};

const ru_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя ученика`)
};

const tr_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğrenci adı`)
};

const hi_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छात्र का नाम`)
};

const id_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama siswa`)
};

const ms_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama pelajar`)
};

const cs_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno žáka`)
};

const el_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Όνομα μαθητή`)
};

const he_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שם התלמיד`)
};

const af_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naam van leerder`)
};

const hu_booking_label_student = /** @type {(inputs: Booking_Label_StudentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diák neve`)
};

/**
* | output |
* | --- |
* | "Student name" |
*
* @param {Booking_Label_StudentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_label_student = /** @type {((inputs?: Booking_Label_StudentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Label_StudentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_label_student(inputs)
	if (locale === "de") return de_booking_label_student(inputs)
	if (locale === "zh") return zh_booking_label_student(inputs)
	if (locale === "ar") return ar_booking_label_student(inputs)
	if (locale === "fr") return fr_booking_label_student(inputs)
	if (locale === "vi") return vi_booking_label_student(inputs)
	if (locale === "sw") return sw_booking_label_student(inputs)
	if (locale === "th") return th_booking_label_student(inputs)
	if (locale === "bs") return bs_booking_label_student(inputs)
	if (locale === "ja") return ja_booking_label_student(inputs)
	if (locale === "ko") return ko_booking_label_student(inputs)
	if (locale === "pt") return pt_booking_label_student(inputs)
	if (locale === "it") return it_booking_label_student(inputs)
	if (locale === "sv") return sv_booking_label_student(inputs)
	if (locale === "nl") return nl_booking_label_student(inputs)
	if (locale === "da") return da_booking_label_student(inputs)
	if (locale === "nb") return nb_booking_label_student(inputs)
	if (locale === "fi") return fi_booking_label_student(inputs)
	if (locale === "pl") return pl_booking_label_student(inputs)
	if (locale === "ru") return ru_booking_label_student(inputs)
	if (locale === "tr") return tr_booking_label_student(inputs)
	if (locale === "hi") return hi_booking_label_student(inputs)
	if (locale === "id") return id_booking_label_student(inputs)
	if (locale === "ms") return ms_booking_label_student(inputs)
	if (locale === "cs") return cs_booking_label_student(inputs)
	if (locale === "el") return el_booking_label_student(inputs)
	if (locale === "he") return he_booking_label_student(inputs)
	if (locale === "af") return af_booking_label_student(inputs)
	if (locale === "hu") return hu_booking_label_student(inputs)
	return en_booking_label_student(inputs)
});